import { useTranslation } from 'react-i18next'

const Footer = () => {
    //console.log(pkg.version)
    const { t } = useTranslation(['Footer'])
    return (
        <footer className="footer dark">
            <div className="left operated-by">
                <p>
                    {t('operatedBy')} <strong>CSCF</strong>
                </p>
            </div>
            <div className="center connected-to">
                <p></p>
            </div>
            <div className="right branch-name">
                <p>Version 1.0.0</p>
            </div>
        </footer>
    )
}

export default Footer
